import React, { useState } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import "./popup.scss";
import { useTranslation } from "react-i18next";
import CommonPopup from "../CommonPopup/commonPopup";

const PoppupBusiness = ({ businessdata, setmodaldetailsBusiness, handleChange, state, personalRef, setPersonalRef, commercialRef, setCommercialRef, businessdatas, handleChanges, handleDelete }) => {

  const [inputValues, setInputValues] = useState(businessdata);
  const { i18n, t } = useTranslation();

  const handleInputChange = (name, value, refType) => {
    if(refType==="personal"){
      setPersonalRef({
        ...personalRef,
        [name]: { ...personalRef[name], value: value },
      });
      handleChanges("personal ref "+name, value);
    }else if(refType==="commercial"){
      setCommercialRef({
        ...commercialRef,
        [name]: { ...commercialRef[name], value: value },
      });
      handleChanges("commercial ref "+name, value);
    }else {
      setInputValues({
        ...inputValues,
        [name]: { ...inputValues[name], value: value },
      });
      setmodaldetailsBusiness({
        ...businessdata,
        [name]: { ...businessdata[name], value: value },
      })
      handleChanges(name, value);
    }
  };
  function handleDeleteClick(val) {
    const updatedData = Object.keys(inputValues)
      .filter(key => key !== val)
      .reduce((acc, key) => {
        acc[key] = businessdata[key];
        return acc;
      },
        {}
      );
    setInputValues(updatedData);
    setmodaldetailsBusiness(updatedData)
  }

  function handleDeleteRef(refType, val) {
    const refData = refType === 'personal' ? personalRef : commercialRef;

    const updatedData = Object.keys(refData)
      .filter(key => key !== val)
      .reduce((acc, key) => {
        acc[key] = refData[key];
        return acc;
      }, {});

    if (refType === 'personal') {
      setPersonalRef(updatedData);
    } else if (refType === 'commercial') {
      setCommercialRef(updatedData);
    }
  }
  return (
    <div className="poupfourths_paras">
      {!(JSON.stringify(inputValues) === JSON.stringify({})) && (
        <CommonPopup
          handleChange={handleChange}
          handleInputChange={handleInputChange}
          inputValues={inputValues}
          handleDeleteClick={handleDeleteClick}
          type={"business"}
          businessType={"business"}
        />
      )}

    </div>
  );
};

export default PoppupBusiness;
